
let platform = {
    plink: localStorage.getItem('pform')==='AU'? 
    process.env.REACT_APP_SERVICEURL_AU : 
    process.env.REACT_APP_SERVICEURL_NZ ,
}

export default platform;


// WEBPACK FOOTER //
// ./src/services/platforms.jsx